export default class AbortService {
	private _abortController: AbortController;
	
	constructor() {
	}
	
	getSignal(): AbortSignal {
		return this._abortController.signal;
	}
	
	abort() {
		this._abortController?.abort?.();
	}
	
	initialize() {
		// При повторной инициализации инстанса старые запросы должны быть отменены 
		if(this._abortController) {
			this.abort();
		}
		
		this._abortController = new AbortController();
	}
}
